import React from 'react';
import { CustomerOrderStats as CustomerOrderStatsState } from 'services/customerOrderOrchestration/types';

export type { CustomerOrderStatsState };

export type CustomerOrderStatsContextValue = {
  customerOrderStatsContext: CustomerOrderStatsState | null;
  setCustomerOrderStatsContext: (arg: CustomerOrderStatsState) => void;
};

const CustomerOrderContext = React.createContext<CustomerOrderStatsContextValue | undefined>(
  undefined,
);

export { CustomerOrderContext };
